var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { Popup, ReactElementFactory, SvgIcon } from "survey-react-ui";
import { CreatorModelElement } from "../ModelElement";
import { SurveyCreatorToolboxItem } from "./ToolboxItem";
var SurveyCreatorToolboxItemGroup = /** @class */ (function (_super) {
    __extends(SurveyCreatorToolboxItemGroup, _super);
    function SurveyCreatorToolboxItemGroup(props) {
        return _super.call(this, props) || this;
    }
    SurveyCreatorToolboxItemGroup.prototype.getUpdatedModelProps = function () {
        return ["creator", "item"];
    };
    Object.defineProperty(SurveyCreatorToolboxItemGroup.prototype, "item", {
        get: function () {
            return this.props.item;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SurveyCreatorToolboxItemGroup.prototype, "model", {
        get: function () {
            return this.props.model;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SurveyCreatorToolboxItemGroup.prototype, "creator", {
        get: function () {
            return this.props.creator;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SurveyCreatorToolboxItemGroup.prototype, "isCompact", {
        get: function () {
            return this.props.isCompact;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SurveyCreatorToolboxItemGroup.prototype, "parentModel", {
        get: function () {
            return this.props.parentModel;
        },
        enumerable: false,
        configurable: true
    });
    SurveyCreatorToolboxItemGroup.prototype.getStateElement = function () {
        return this.item;
    };
    SurveyCreatorToolboxItemGroup.prototype.render = function () {
        var _this = this;
        return React.createElement(React.Fragment, null,
            React.createElement(SurveyCreatorToolboxItem, { item: this.item, creator: this.creator, model: this.model, parentModel: this.parentModel, isCompact: this.isCompact }),
            React.createElement("div", { className: "svc-toolbox__item-submenu-button", onMouseOver: function (event) { return _this.model.onMouseOver(_this.item, event); }, onMouseLeave: function (event) { return _this.model.onMouseLeave(_this.item, event); } },
                React.createElement(SvgIcon, { size: "auto", iconName: this.item.subitemsButtonIcon }),
                React.createElement(Popup, { model: this.item.popupModel })));
    };
    return SurveyCreatorToolboxItemGroup;
}(CreatorModelElement));
export { SurveyCreatorToolboxItemGroup };
ReactElementFactory.Instance.registerElement("svc-toolbox-item-group", function (props) {
    return React.createElement(SurveyCreatorToolboxItemGroup, props);
});
